import { useModelCompareTranslation } from "constants/modelCompareData/translations/useModelCompareTranslation";import { useMenu } from "@ubnt/store.core/lib/contexts/MenuContext";
import { imageSrc } from "@ubnt/store.core/lib/utils/asset";
import { Reveal } from "@ubnt/store.core/lib/components/Reveal";
import * as S from "../../../CompareTable.styles";
import type { EmptyColumnHeaderProps } from "./EmptyColumnHeader.types";

// #############################################################################
// Renders headers for empty columns
// #############################################################################
export const EmptyColumnHeader = ({
  product,
  index,
  hasBeenObserved,
  maxImageHeight,
  headerItemsAreSticking,
}: EmptyColumnHeaderProps) => {
  const { formatMessage } = useModelCompareTranslation();
  const { languageDirection } = useMenu();

  return (
    <S.EmptyHeaderGridItem>
      <Reveal index={index} playAnimation={hasBeenObserved}>
        <S.HeaderGridItemContainer
          style={{ height: `${maxImageHeight}px` }}
          $isStuck={headerItemsAreSticking}
        >
          <S.ProductImageWrap height={product.image.height}>
            <S.ProductImage
              src={imageSrc(product.image.src)}
              width={product.image.width}
              alt={product?.productTitle}
            />
          </S.ProductImageWrap>
          <S.ProductDescription
            $maxWidth={product.descriptionMaxWidth}
            $direction={languageDirection}
          >
            {formatMessage("commons.emptyColumn.description")}
          </S.ProductDescription>
        </S.HeaderGridItemContainer>
      </Reveal>
      <S.SelectFromAboveIsStuckContainer $isStuck={headerItemsAreSticking}>
        <S.SelectFromAboveIsStuck
          $maxWidth={product.descriptionMaxWidth}
          $direction={languageDirection}
        >
          {formatMessage("commons.emptyColumn.description")}
        </S.SelectFromAboveIsStuck>
      </S.SelectFromAboveIsStuckContainer>
    </S.EmptyHeaderGridItem>
  );
};
